import React from "react";

export default function VisibleIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 54 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.5018 20C34.5018 24.1423 31.144 27.5 27.0018 27.5C22.8598 27.5 19.5018 24.1423 19.5018 20C19.5018 15.8577 22.8598 12.5 27.0018 12.5C31.144 12.5 34.5018 15.8577 34.5018 20Z"
        stroke="#35d4ae"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.003 2.5C15.8089 2.5 6.33316 9.8572 3.14746 20C6.33311 30.1427 15.8089 37.5 27.003 37.5C38.197 37.5 47.6728 30.1427 50.8585 20C47.6728 9.85728 38.197 2.5 27.003 2.5Z"
        stroke="#35d4ae"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
